/* eslint-disable import/prefer-default-export */
type CustomItem = {
  key: number;
  label: string;
  value: boolean;
};

type DataObject = {
  [key: string]: boolean | string | CustomItem[] | undefined;
  custom?: CustomItem[];
};

export function checkForRemovedFreightModes(initialInvitedModes: DataObject, invitedModes: DataObject): boolean {
  if (!initialInvitedModes || Object.keys(initialInvitedModes).length === 0) return false;
  // Check missing top-level keys or different boolean values
  if (
    Object.keys(initialInvitedModes).some(
      (key) => !(key in invitedModes) || (initialInvitedModes[key] === true && invitedModes[key] === false),
    )
  ) {
    return true;
  }

  // Handle the "custom" array if present
  if (Array.isArray(initialInvitedModes.custom) && Array.isArray(invitedModes.custom)) {
    const customKeys1 = new Map(initialInvitedModes.custom.map((item) => [item.key, item.value]));
    const customKeys2 = new Map(invitedModes.custom.map((item) => [item.key, item.value]));

    if (
      [...customKeys1].some(([key, value]) => !customKeys2.has(key) || (value === true && customKeys2.get(key) === false))
    ) {
      return true;
    }
  } else if (initialInvitedModes.custom && !invitedModes.custom) {
    return false; // Entire custom array is missing
  }

  return false;
}
